import Image, { StaticImageData } from 'next/image';
import React from 'react';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';

import { cn } from '@cineamo/ui/src/helpers/cn';

export type ListPlaceholderProps = {
    classNameText?: string;
    classNameTitle?: string;
    classNamePadding?: string;
    classNameSpacing?: string;
    image?: StaticImageData | string;
    customImageComponent?: React.JSX.Element;
    title?: string;
    text?: string | React.JSX.Element;
    buttonText?: string;
    buttonStyle?: ButtonStyle;
    onButtonClick?: () => void;
};

function ListPlaceholder(props: ListPlaceholderProps): React.JSX.Element {
    const {
        classNameText,
        classNameTitle,
        classNamePadding,
        classNameSpacing,
        customImageComponent,
        image,
        title,
        text,
        buttonText,
        onButtonClick
    } = props;

    return (
        <div
            className={cn(
                'flex flex-col justify-center items-center',
                classNamePadding ?? 'p-48 md:p-64',
                classNameSpacing ?? 'space-y-24'
            )}>
            {image && (
                <Image
                    className="w-10/12 md:w-1/2 max-w-300 object-contain"
                    src={image}
                    width={800}
                    height={600}
                    alt="No list items"
                />
            )}
            {customImageComponent || null}
            <div className="flex flex-col space-y-48">
                {(title || text) && (
                    <div className="flex flex-col space-y-8">
                        {title && (
                            <span className={cn('text-headline-18 lg:text-headline-20 text-center', classNameTitle)}>
                                {title}
                            </span>
                        )}
                        {text && (
                            <span
                                className={cn(
                                    'text-body-14 font-montserrat-medium whitespace-pre-wrap text-center',
                                    classNameText
                                )}>
                                {text}
                            </span>
                        )}
                    </div>
                )}
                {buttonText && (
                    <Button
                        style={props.buttonStyle || ButtonStyle.default_no_padding}
                        onClick={() => {
                            onButtonClick?.();
                        }}>
                        {buttonText}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default ListPlaceholder;
